import * as tslib_1 from "tslib";
import { DatapointStatus } from 'owa-analytics/lib/types/DatapointEnums';
import { PerformanceDatapoint } from 'owa-analytics';
import loadSharedCalendarsConfiguration from '../services/loadSharedCalendarsConfiguration';
import parseCalendarFoldersResponse from '../utils/parseCalendarFoldersResponse';
import { trace } from 'owa-trace';
import updateSharedCalendarsInitialState from '../data/mutators/updateSharedCalendarsInitialState';
/**
 * 1. Gets the calendar folder and groups data from the server
 * 2. Parses the data to get the initial state of the shared calendars
 * 3. Calls an action to update the store with the parsed data
 */
export default function initSharedCalendarsConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var dataPoint, calendarFoldersResponse, initialViewState, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dataPoint = new PerformanceDatapoint('InitSharedCalendarsOption');
                    return [4 /*yield*/, loadSharedCalendarsConfiguration()];
                case 1:
                    calendarFoldersResponse = _a.sent();
                    if (calendarFoldersResponse.CalendarFolders &&
                        calendarFoldersResponse.CalendarFolders.length &&
                        calendarFoldersResponse.CalendarGroups &&
                        calendarFoldersResponse.CalendarGroups.length) {
                        dataPoint.end();
                        initialViewState = parseCalendarFoldersResponse(calendarFoldersResponse);
                        updateSharedCalendarsInitialState(initialViewState);
                        return [2 /*return*/, true];
                    }
                    else {
                        dataPoint.endWithError(DatapointStatus.ServerError, new Error('Request returned empty response'));
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    dataPoint.endWithError(DatapointStatus.RequestNotComplete, new Error('Request failed'));
                    trace.warn(e_1.message || 'initSharedCalendarsConfiguration failed');
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=initSharedCalendarsConfiguration.js.map